module.exports = __webpack_public_path__ + "static/img/device-mockup04.4fb8b51.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life/device-mockup04.png
// module id = e+vn
// module chunks = 0